'use client';
import { useCallback, useRef, useSyncExternalStore } from 'react';
import {
  parseMatchFilterUrl,
  serializeMatchFilterUrl,
  type MatchFilterUrl,
} from '../../libs/matchFilterUrl';
const event = 'event-filter-url';
const subscribe = (notify: () => void) => {
  window.addEventListener('popstate', notify);
  window.addEventListener(event, notify);
  return () => {
    window.removeEventListener('popstate', notify);
    window.removeEventListener(event, notify);
  };
};
/** Native history integrates with Next navigation, and keeps fast consecutive edits atomic. */
export function useMatchFilterUrl() {
  const wroteInAction = useRef(false);
  const query = useSyncExternalStore(
    subscribe,
    () => window.location.search,
    () => '',
  );
  const state = parseMatchFilterUrl(new URLSearchParams(query));
  const update = useCallback((patch: Partial<MatchFilterUrl>, replace = false) => {
    const current = new URLSearchParams(window.location.search);
    const next = serializeMatchFilterUrl(current, { ...parseMatchFilterUrl(current), ...patch });
    const href = window.location.pathname + (next.size ? `?${next}` : '') + window.location.hash;
    if (href === window.location.pathname + window.location.search + window.location.hash) return;
    window.history[replace || wroteInAction.current ? 'replaceState' : 'pushState'](null, '', href);
    if (!replace) {
      wroteInAction.current = true;
      queueMicrotask(() => {
        wroteInAction.current = false;
      });
    }
    window.dispatchEvent(new Event(event));
  }, []);
  return { state, update };
}
